<fgb-page-header
  [pageTitle]="'nav.worksheets'"
  [showBalance]="false"
  [backButtonLink]="'/'"
  [kidsBanner]="'banners/kids-worksheets.jpg'"
></fgb-page-header>

<div class="pt-lg-4">
  <fgb-worksheet-list [hasWorksheetTitle]="false"></fgb-worksheet-list>
</div>
